module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oID6Lf/tc-custom/9781035801244.jpg?1705539782337",
      "alt": "This image is the cover for the book Deadly Imprint"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deadly Imprint\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Elaine and Laura do not know each other but their lives are linked by events which happened generations ago. Elaine’s contentment is disrupted by an impulse buy a book with supernatural properties which proves to be damaging to her physical and mental health. Laura is behaving irrationally because she is distraught about her seriously ill daughter Lilly and is on a course to make things worse with the help of a conman who is pretending to be a doctor. Tess, a shadow from the past, is there to help them both.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iago Roberts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen and Iago are a mother and son team. Helen loves to write and Iago likes to think up plots and ideas. Helen was born in Liverpool in 1953 and has spent most of her life working in science and research. Iago was born in Bern in 1982 and runs a village pub and microbrewery of which he is part owner.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0